/**
 * The address of one person's page.
 *
 * A lobbyist is the only subject on this site the government issues no
 * identifier for. The LD-2 carries a `lobbyist_id` and it is per registrant
 * — not one of the seven thousand in this corpus appears at two
 * organisations — so it names a seat at a firm rather than a person. A page
 * is therefore keyed on the organisation and the name together, which is
 * exactly the claim the filings support.
 *
 * This rule exists three times: here, in `wearethelaw.lobbyist.slug`, and as
 * SQL in the store that resolves it. They have to agree character for
 * character over every name in the record, because they fail silently when
 * they do not — the link renders, the page 404s, and only for the people
 * with an apostrophe or an accent in their name. Each copy is tested against
 * the same list.
 */

/** A URL-safe key for one person's name, or "" for a name with nothing in it. */
export function slug(name: string): string {
  return (
    name
      // Folded rather than stripped: dropping the accents leaves "jos" and
      // "lvarez", which are unreadable and can collide for two people.
      .normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
  );
}

/** Where one person's page lives, given the organisation that named them. */
export function lobbyistPath(registrantId: number, name: string): string {
  return `/money/${registrantId}/lobbyist/${slug(name)}`;
}
